<template>
  <v-snackbar
    v-model="show"
    :timeout="timeout"
    :color="color">
    {{ message }}
    <v-btn
      flat
      @click="show = false">
      <v-icon>close</v-icon>
    </v-btn>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {
      show: false,
      color: 'info',
      message: '',
      timeout: 6000
    }
  },
  computed: {
    snack() {
      return this.$store.state.snack
    }
  },
  created() {
    this.$store.watch(state => state.snack, () => {
      var message = this.snack.message
      if (message !== '') {
        this.show = true
        this.message = this.snack.message
        this.timeout = this.snack.timeout != undefined ? this.snack.timeout : 6000
        this.color = this.snack.color
        this.$store.commit("setSnack", { message: "", color: "" })
      }
    })
  }
}
</script>
<style>
</style>
